import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
import { event } from "jquery";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { validate } from "../../login/validate";
// config
import configData from "../../../config/config.json";
// components
import AlertSuccess from "../../AlertSuccess/AlertSuccess";
import AlertError from "../../AlertError/AlertError";

// rtl
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const InformationStep2b = () => {
  const [dataCome, setDataCome] = useState(false);
  const [disable, setDisable] = useState(false);

  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  const [errorAlert, setErrorAlert] = useState(null);
  const errorAlertHandeler = (lang) => {
    setErrorAlert(lang);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setErrorAlert(null);
    }, 4000);
  };

  const [Titles, setTitles] = useState({
    EnName: "",
    FaName: "",
  });
  const [Job, setJob] = useState({
    EnJob: "",
    FaJob: "",
  });

  // validate
  const [errors1, setErrors1] = useState({});
  const [touched1, setTouched1] = useState({});
  const [errors2, setErrors2] = useState({});
  const [touched2, setTouched2] = useState({});

  useEffect(() => {
    setErrors1(validate(Titles, "dashboard-s1-1"));
  }, [Titles, touched1]);
  useEffect(() => {
    setErrors2(validate(Job, "dashboard-s1-2"));
  }, [Job, touched2]);

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  const nameHandler = (e) => {
    if (e.target.name == "EnName") {
      setTitles({
        ...Titles,
        [e.target.name]: e.target.value.replace(/[^A-Za-z0-9\s,]/gi, ""),
      });
      // Validate input to allow only English characters, numbers, and spaces
      if (!/^[a-zA-Z0-9 ]*$/.test(e.target.value)) {
        errorAlertHandeler("انگلیسی");
      }
    } else {
      setTitles({
        ...Titles,
        [e.target.name]: e.target.value,
      });
      // setTitles({
      //   ...Titles,
      //   [e.target.name]: e.target.value.replace(/[^آ-ی0-9 ]/g, ""),
      // });
      // // Validate input to allow only Farsi characters, numbers, and spaces
      // if (!/^[آ-ی0-9 ]*$/.test(e.target.value)) {
      //   errorAlertHandeler("فارسی");
      // }
    }
  };

  const jobHandler = (e) => {
    if (e.target.name == "EnJob") {
      setJob({
        ...Job,
        [e.target.name]: e.target.value.replace(/[^A-Za-z0-9\s,]/gi, ""),
      });
      // Validate input to allow only English characters, numbers, and spaces
      if (!/^[a-zA-Z0-9 ]*$/.test(e.target.value)) {
        errorAlertHandeler("انگلیسی");
      }
    } else {
      setJob({
        ...Job,
        [e.target.name]: e.target.value,
      });
      // setJob({
      //   ...Job,
      //   [e.target.name]: e.target.value.replace(/[^آ-ی0-9 ]/g, ""),
      // });
      // // Validate input to allow only Farsi characters, numbers, and spaces
      // if (!/^[آ-ی0-9 ]*$/.test(e.target.value)) {
      //   errorAlertHandeler("فارسی");
      // }
    }
  };

  useEffect(() => {
    setDataCome(false);

    axios
      .get(
        configData.API_DOMAIN + `/api/v1/Businesses/${getCookie("BizUuid")}`, // the business Guuid that gets from login
        {
          headers: header,
        }
      )
      .then((response) => {
        setDataCome(true);
        if (response.data.isSuccess) {
          let data = response.data.data;
          setTitles({
            FaName: data?.faTitle,
            EnName: data?.enTitle,
          });
          setJob({
            FaJob: data?.faJobTitle,
            EnJob: data?.enJobTitle,
          });
        }
      })
      .catch((error) => {
        // alert(error);
      });

    // load api bu aidin
    // axios
    //   .get(domain + "/api/biz/titles", {
    //     headers: header,
    //   })
    //   .then((response) => {
    //     if (response.data.msg == "done") {
    //       setDataCome(true);
    //       if (response.data.Titles) {
    //         var x = response.data.Titles;
    //         setTitles({
    //           FaName: x.FaTitle,
    //           EnName: x.EnTitle,
    //         });
    //         setJob({
    //           FaJob: x.FaJobTitle,
    //           EnJob: x.EnJobTitle,
    //         });
    //       }
    //     }
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });
  }, []);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const submitHandler = (event) => {
    event.preventDefault();
    if (!Object.keys(errors1).length && !Object.keys(errors2).length) {
      setDisable(true);

      const dataPost = {
        // FaTitle: Titles.FaName,
        // EnTitle: Titles.EnName,
        // FaJobTitle: Job.FaJob,
        // EnJobTitle: Job.EnJob,

        id: getCookie("BizUuid"),
        bId: getCookie("BizId"),
        enTitle: Titles.EnName,
        faTitle: Titles.FaName,
        enJobTitle: Job.EnJob,
        faJobTitle: Job.FaJob,
      };

      axios
        .post(configData.API_DOMAIN + "/api/v1/Businesses", dataPost, {
          headers: header,
        })
        .then((response) => {
          setDisable(false);
          if (response.data.isSuccess) {
            // success
            alertHandeler();
          }
        })
        .catch((error) => {
          // alert(error);
        });
    } else {
      if (Object.keys(errors1).length) {
        setTouched1({
          EnName: true,
        });
      }
      if (Object.keys(errors2).length) {
        setTouched2({
          EnJob: true,
        });
      }
    }
  };

  return (
    <>
      <div className="part_three_info">
        <div className="">
          {dataCome ? (
            <>
              <div>
                <p className="is2b-tit mb-0">ویرایش نام کسب‌‌وکار</p>
                <p className="eng-per-title text-start mt-0">*English</p>
                <TextField
                  dir="ltr"
                  type="text"
                  value={Titles.EnName}
                  onChange={nameHandler}
                  name="EnName"
                  id="outlined-basic"
                  // label="English buisness name"
                  placeholder="Example: vikifa, Dr.Reza Kazemi..."
                  variant="outlined"
                  className={
                    errors1.EnName && touched1.EnName
                      ? " custom-text-field width-100 mb-2 font-family-en custom-text-field-error"
                      : " custom-text-field width-100 mb-2 font-family-en"
                  }
                  required
                />
                {errors1.EnName && touched1.EnName && (
                  <span className="input-error me-1">{errors1.EnName}</span>
                )}
                <p className="eng-per-title text-end mt-0">فارسی</p>
                <CacheProvider value={cacheRtl}>
                  <ThemeProvider theme={theme}>
                    <TextField
                      dir="rtl"
                      type="text"
                      value={Titles.FaName}
                      onChange={nameHandler}
                      name="FaName"
                      id="outlined-basic"
                      // label="نام کسب‌و‌کار به فارسی"
                      placeholder="مثال: ویکیفا، دکتر رضا کاظمی..."
                      variant="outlined"
                      className={" custom-text-field width-100 mb-0 "}
                    />
                  </ThemeProvider>
                </CacheProvider>
              </div>
              {/* <div>
                <p className="is2b-tit">ویرایش نام کسب‌وکار </p>

                <TextField
                  dir="ltr"
                  type="text"
                  // value={data.AddressLine1}
                  // onChange={CheckAddress}
                  id="outlined-basic"
                  label="English buisness name"
                  variant="outlined"
                  className={
                    "label-field-zero custom-text-field width-100 mb-3 "
                  }
                />
                <CacheProvider value={cacheRtl}>
                  <ThemeProvider theme={theme}>
                    <TextField
                      dir="ltr"
                      type="text"
                      // value={data.AddressLine1}
                      // onChange={CheckAddress}
                      id="outlined-basic"
                      label="نام کسب‌و‌کار به فارسی"
                      variant="outlined"
                      className={
                        "label-field-more7 custom-text-field width-100 mb-0 "
                      }
                    />
                  </ThemeProvider>
                </CacheProvider>
              </div> */}

              <div>
                <p className="is2b-tit mb-0 mt-4">ویرایش عنوان شغلی</p>
                <p className="eng-per-title text-start mt-0">*English</p>
                <TextField
                  dir="ltr"
                  type="text"
                  value={Job.EnJob}
                  onChange={jobHandler}
                  name="EnJob"
                  id="outlined-basic"
                  // label="English buisness name"
                  placeholder="Example: Immigration Lawyer, Persian Restaurant, Cardiologist..."
                  variant="outlined"
                  className={
                    errors2.EnJob && touched2.EnJob
                      ? " font-family-en custom-text-field width-100 mb-2 custom-text-field-error"
                      : " font-family-en custom-text-field width-100 mb-2"
                  }
                  required
                />
                {errors2.EnJob && touched2.EnJob && (
                  <span className="input-error me-1">{errors2.EnJob}</span>
                )}
                <p className="eng-per-title text-end mt-0">فارسی</p>
                <CacheProvider value={cacheRtl}>
                  <ThemeProvider theme={theme}>
                    <TextField
                      dir="rtl"
                      type="text"
                      value={Job.FaJob}
                      onChange={jobHandler}
                      name="FaJob"
                      id="outlined-basic"
                      // label="نام کسب‌و‌کار به فارسی"
                      placeholder="مثال: وکیل مهاجرت، رستوران ایرانی، متخصص قلب..."
                      variant="outlined"
                      className=" custom-text-field width-100 mb-0 "
                    />
                  </ThemeProvider>
                </CacheProvider>
              </div>
            </>
          ) : (
            <>
              <Skeleton
                className="radius2 mt-3"
                variant="rectangular"
                height={30}
                animation="wave"
              />
              <Skeleton
                className="radius2 mt-3"
                variant="rectangular"
                height={30}
                animation="wave"
              />
            </>
          )}
        </div>
        <div className=" step2_save_c">
          {dataCome ? (
            <button
              onClick={submitHandler}
              disabled={disable}
              className="btn_information_submit"
            >
              ذخیره اطلاعات
            </button>
          ) : (
            <Skeleton
              className="btn_information_submit me-auto"
              variant="rectangular"
              height={39}
              animation="wave"
            />
          )}
        </div>
        {/* alert delete */}
        <AlertSuccess
          showAlert={showAlert}
          text={" اطلاعات شما با موفقیت ثبت شد."}
        />
      </div>
      {/* alert error */}
      <AlertError
        showAlert={errorAlert}
        text={`زبان کیبورد را به ${errorAlert} تغییر دهید.`}
      />
    </>
  );
};

export default InformationStep2b;
